import { userValueFormat } from 'helpers';

type ValueAxisTickProps = {
  x?: number;
  y?: number;
  payload?: { value: number };
  dataType: string;
};

const ValueAxisTick = ({ x, y, payload, dataType }: ValueAxisTickProps) => {
  if (x === undefined || y === undefined || !payload?.value) return <></>;
  return (
    <g transform={`translate(${x}, ${y})`}>
      <text
        x={0}
        y={0}
        textAnchor='end'
        fill='var(--warm-grey-300)'
        style={{ fontSize: 'var(--font-size-chart-label)' }}
      >
        {userValueFormat(payload.value, dataType)}
      </text>
    </g>
  );
};

export default ValueAxisTick;
